import { render, staticRenderFns } from "./BaseSelectUploadResource.vue?vue&type=template&id=26c9f402&scoped=true&"
import script from "./BaseSelectUploadResource.vue?vue&type=script&lang=js&"
export * from "./BaseSelectUploadResource.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectUploadResource.vue?vue&type=style&index=0&id=26c9f402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c9f402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c9f402')) {
      api.createRecord('26c9f402', component.options)
    } else {
      api.reload('26c9f402', component.options)
    }
    module.hot.accept("./BaseSelectUploadResource.vue?vue&type=template&id=26c9f402&scoped=true&", function () {
      api.rerender('26c9f402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseSelectUploadResource.vue"
export default component.exports